import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const isActive = (path: string) => location.pathname === path ? 'active' : '';

  return (
    <div>
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          <img src="/assets/favicon.svg" alt="WorkDoe" />
          <span>WorkDoe</span>
        </Link>
        <div className="navbar-links">
          {user?.role === 'homeowner' && (
            <>
              <Link to="/dashboard" className={isActive('/dashboard')}>Dashboard</Link>
              <Link to="/send-a-doe" className={isActive('/send-a-doe')}>Send a Doe</Link>
              <Link to="/chat" className={isActive('/chat')}>Chat</Link>
            </>
          )}
          {user?.role === 'contractor' && (
            <>
              <Link to="/contractor-dashboard" className={isActive('/contractor-dashboard')}>Dashboard</Link>
              <Link to="/chat" className={isActive('/chat')}>Chat</Link>
            </>
          )}
          {user ? (
            <button onClick={handleLogout} className="chip">Logout</button>
          ) : (
            <Link to="/login"><button className="btn-primary">Get Started</button></Link>
          )}
        </div>
      </nav>

      <main>{children}</main>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Moose Bay &amp; Company LLC</p>
        <p>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/security">Security</Link>
          <Link to="/contractor-agreement">Contractor Agreement</Link>
          <Link to="/consumer-agreement">Consumer Agreement</Link>
        </p>
        <p className="disclaimer" style={{ marginTop: '8px', maxWidth: '600px', margin: '8px auto 0' }}>
          WorkDoe is a matching platform only. We are not responsible for the quality, safety, or completion of any work performed, nor for any payments exchanged between homeowners and contractors.
        </p>
      </footer>
    </div>
  );
}
